







































































































































































































































import { Component, Vue } from "vue-property-decorator";
import OrderModule from "@/store/order";
import AuthModule from "@/store/auth";
import { OrderStatus, Order, SortDirection, OrderType } from "@/api/api";
import moment from "moment";
import { OrdersApi, RestaurantsApi } from "@/services/api-service";
import { toUpperFirstLetter } from "@/utils/Util";
import Pagination from "@/components/Pagination.vue";

@Component({
  components: {
    Pagination,
  },
})
export default class OrderList extends Vue {
  private get orders() {
    return OrderModule.orders;
  }

  private get me() {
    return AuthModule.me;
  }

  private get moment() {
    return moment;
  }

  private get OrderStatus() {
    return OrderStatus;
  }

  private get currentDate() {
    return OrderModule.currentDate;
  }

  private currentOrder: Order | null = null;

  private windowWidth: number | null = null;

  private displayStatus(status: OrderStatus) {
    if (status === OrderStatus.Checking) {
      return "未確認";
    }
    if (status === OrderStatus.Processing) {
      return "受付中";
    }
    if (status === OrderStatus.Completed) {
      return "完了";
    }
    return "";
  }

  private displayOrderType(orderType: OrderType) {
    if (orderType === OrderType.Takeout) {
      return "テイクアウト";
    }
    if (orderType === OrderType.Delivery) {
      return "デリバリー";
    }
    return "";
  }

  private showModal(name: string, order: Order) {
    this.currentOrder = order;
    this.$modal.show(`${name}`);
  }

  private closeModal(name: string) {
    this.currentOrder = null;
    this.$modal.hide(name);
    // document.body.classList.remove("modal-open");
  }

  private async changeStatus(status: OrderStatus) {
    if (!this.currentOrder?.uuid) {
      return;
    }
    try {
      await OrdersApi.instance.patchOrder(this.currentOrder.uuid, {
        orderStatus: status,
      });
      await this.getOrders();
      this.closeModal(`operation${toUpperFirstLetter(status)}`);
    } catch (err) {
      console.log(err);
    }
  }

  // @Watch("$route", { deep: true })
  private async getOrders() {
    const limit = 8;
    const pageNum = this.$route.params?.pageNum ? Number(this.$route.params.pageNum) : 0;
    if (!this.me?.uuid || typeof this.me?.uuid !== "string") {
      return;
    }
    try {
      // eslint-disable-next-line prettier/prettier
      const ordersRes = await RestaurantsApi.instance.
      getOrdersByRestaurantUuid(
        this.me?.uuid,
        limit,
        pageNum === 0 ? 0 : (pageNum - 1) * limit,
        SortDirection.Desc,
        "createdAt",
        this.currentDate ? this.currentDate.toISOString() : undefined
      );
      // eslint-disable-next-line prettier/prettier
      if (!ordersRes.data.data?.items || !(ordersRes.data.data.items.length > 0)) {
        throw Error("Orders not found");
      }
      OrderModule.commitOrders(ordersRes.data.data.items);
    } catch (err) {
      console.log(err);
    }
  }

  private mounted() {
    window.addEventListener("resize", this.calcWindowWidth);
    this.calcWindowWidth();
  }

  private beforeDestroy() {
    window.removeEventListener("resize", this.calcWindowWidth);
    this.calcWindowWidth();
  }

  private calcWindowWidth() {
    this.windowWidth = window.innerWidth;
  }
}
